module.exports = __webpack_public_path__ + "static/media/marketing-4-checked.9036c16c.png";